export const MoodOptions = [
    { value: '1', id: 'hate' },
    { value: '2', id: 'dislike' },
    { value: '3', id: 'neutral' },
    { value: '4', id: 'like' },
    { value: '5', id: 'love' }
];
